import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowShareRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowShareRight"><Path d="M23.5052 12.0003L12 1.77344V7.51462C8.20052 7.62727 5.40877 8.41778 3.58061 10.3814C1.61445 12.4932 1 15.716 1 20.0003L2.89443 20.4475C3.64019 18.956 4.14254 18.1095 5.32221 17.5197C6.49021 16.9357 8.41054 16.5647 12 16.5079V22.2271L23.5052 12.0003Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowShareRight;
